import React from "react";
import { useField, useFormikContext } from "formik";
import { FormGroup, Input, Label } from "reactstrap";
import { FormFieldRow } from "./formFieldRow";
import { HEX_COLOR_REGEX, normalizeHexColor } from "../../../../../components/common/HexColorSelector";

export { HEX_COLOR_REGEX };

interface FormColorRowProps {
    name: string;
    label: string;
    fallbackColor: string;
    allowNull?: boolean;
    hidden?: boolean;
}

export const FormColorRow = (props: FormColorRowProps) => {
    const [field, meta, helpers] = useField<string | null | undefined>(
        props.name
    );
    const { submitCount } = useFormikContext();
    const rawValue = field.value ?? "";
    const hasNoColor = (props.allowNull ?? false) && !rawValue;
    const colorValue = normalizeHexColor(rawValue, props.fallbackColor);
    const showError = meta.touched || submitCount > 0;
    const error =
        showError && typeof meta.error === "string" ? meta.error : undefined;

    const setColorValue = (value: string | null) => {
        helpers.setValue(value);
    };

    return (
        <FormFieldRow label={props.label} error={error} hidden={props.hidden}>
            <div className="d-flex gap-2 align-items-center">
                <Input
                    type="color"
                    value={colorValue}
                    disabled={hasNoColor}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setColorValue(event.target.value.toUpperCase())
                    }
                    style={{
                        width: 44,
                        height: 38,
                        padding: 4,
                        flex: "0 0 auto",
                        cursor: hasNoColor ? "not-allowed" : "pointer",
                    }}
                />
                <Input
                    type="text"
                    value={rawValue}
                    placeholder="#RRGGBB"
                    disabled={hasNoColor}
                    invalid={!!error}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setColorValue(event.target.value.toUpperCase())
                    }
                    style={{ maxWidth: 140 }}
                />
                {props.allowNull && (
                    <FormGroup check className="mb-0">
                        <Label check>
                            <Input
                                type="checkbox"
                                checked={hasNoColor}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                    setColorValue(event.target.checked ? null : props.fallbackColor)
                                }
                            />
                            None
                        </Label>
                    </FormGroup>
                )}
            </div>
        </FormFieldRow>
    );
};